import { customerService } from '../../services'
import { getField, updateField } from 'vuex-map-fields';

const state = {
  allCustomers: {},
  selectedCustomer: {}
}

const actions = {
  getAll ({ commit }) {
    commit('getAllRequest')
    return customerService.getAll()
      .then(
        customers => {
          commit('getAllCustomerSuccess', customers)
          return customers
        },
        error => commit('getAllCustomerFailure', error)
      )
  },
  addNewCustomer ({ commit }, customer) {
    commit('addNewCustomerRequest')
    return customerService.addNewCustomer(customer)
      .then(
        customer => {
          return customer
        },
        error => {
          commit('addNewCustomerFailure', error)
          return Promise.reject(error)
        }
      )
  },
  updateCustomer ({ commit }, customer) {
    commit('updateCustomerRequest')
    return customerService.updateCustomer(customer)
      .then(
        customer => {
          commit('updateCustomerSuccess', customers)
          return customer
        },
        error => {
          commit('updateCustomerFailure', error)
          return Promise.reject(error)
        }
      )
  },
  selectCustomer ({ commit }, customer) {
    console.log(customer);
    commit('customerSelected', customer)
  }
}

const mutations = {
  updateField,
  getAllRequest (state) {
    state.allCustomers = { loading: true }
  },
  getAllCustomerSuccess (state, customers) {
    state.allCustomers = { items: customers }
  },
  getAllFailure (state, error) {
    state.allCustomers = { error }
  },
  addNewCustomerRequest (state) {
    state.loading=true
  },
  addNewCustomerSuccess (state, customer) {
    state.selectedCustomer = customer
  },
  updateCustomerSuccess (state, customer) {
    state.selectedCustomer = customer
  },
  addNewCustomerFailure (state, error) {
    state.selectedCustomer = { error }
  },
  updateCustomerFailure (state, error) {
    state.selectedCustomer = { error }
  },
  customerSelected (state, customer) {
    console.log(state)
    state.selectedCustomer = customer
  }
}

export const customers = {
  getters: {
    getField,
  },
  namespaced: true,
  state,
  actions,
  mutations
}
